import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const ArtPage = () => (
  <Layout>
      <div class="container col-8">
    <SEO title="Pembuatan website artis pekerja seni" />
    <h1><strong><a href="/art" class="text-primary" title="jasa pembuatan website artis pekerja seni">ARTIST ART WORKER</a></strong></h1><hr/>
<p>Special dan wajib untuk artis pekerja seni dalam menggunakan website untuk sarana promosi maupun sebagai ID dan menampilkan hasil karya mereka via online website nya, agar lebih terpercaya akan skill yang dimiliki nya.</p>
    <div class="embed-responsive embed-responsive-21by9 rounded">
    <iframe title="pembuatan website toko alat music" width="560" height="315" src="https://www.youtube.com/embed/aVnJjak-CVA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
<p>Layanan <a href="/art" class="text-primary" title="jasa pembuatan website artis pekerja seni">jasa pembuatan website untuk artis dan art worker</a> dapat kamu gunakan dalam kebutuhan mu baik untuk promosi maupun sebagai icon secara online, dengan desain terbaik dan dukungan foto image editing hingga video cinematic semakin menarik mewah dan elegan dalam kebutuhan pembuatan website art.</p>
<p>Menggunakan desain yang unik semakin menarik bagi pelanggan untuk mendapatkan informasi mengenai toko alat music dan jasa service bidang music mu.</p>
   <p>Segera buat website kamu sekarang untuk masa depan lebih baik dalam kemajuan bisnis mu.</p>
    <Link class="btn btn-lg btn-primary rounded-pill p-3 md-5" to="/price">Price list</Link>
    <Link class="btn btn-lg btn-primary rounded-pill p-3 md-5" to="/">Home Page</Link>
    <br/><br/>
    </div>
  </Layout>
)

export default ArtPage
